module.exports = __webpack_public_path__ + "img/vertical_7_3_8011.cb6719dc.png";